import { computed } from 'vue';
import tinycolor from 'tinycolor2';
import { useLink } from '../component-lib.esm6.js';
import { LINK_PROPS } from '../component-lib.esm3.js';
import ProfileLinkWrapper from '../component-lib.esm4.js';
import { useProfile } from '../compositions/component-lib.esm4.js';
import { useTheme } from '../../compositions/component-lib.esm7.js';

//
var script = {
  props: LINK_PROPS,
  components: {
    ProfileLinkWrapper
  },
  setup(props, _ref) {
    let {
      emit
    } = _ref;
    const {
      id
    } = useLink(props, {
      emit
    });
    const theme = useTheme();
    const profile = useProfile();
    const html = computed(() => {
      return props.link.text_options.html;
    });
    const classes = computed(() => {
      return {
        'site-links-text--centered': props.link.text_options.center_text,
        'site-links-text--remove-bg': props.link.text_options.remove_bg
      };
    });
    const styles = computed(() => {
      let background = tinycolor(theme.value.profile.bgColor);
      let textColor = tinycolor(theme.value.profile.textColor);
      // If the user has a custom theme and is using a gradient, use a gradient color as the bg
      if (profile.value.site_theme === 'custom' && profile.value.site_bg_style === 'gradient') {
        background = tinycolor(profile.value.site_bg_colors[0]);
        textColor = tinycolor.mostReadable(background, [textColor, '#fff', '#000'], {
          includeFallbackColors: true
        });
      }
      const highlightBgColor = background.isDark() ? tinycolor(background.toRgbString()).lighten(10).setAlpha(0.75).toRgbString() : tinycolor(background.toRgbString()).darken(10).setAlpha(0.75).toRgbString();
      return {
        '--c-bg-color': background.toRgbString(),
        '--c-text-color': textColor.toRgbString(),
        '--c-highlight-bg-color': highlightBgColor,
        '--c-highlight-color': tinycolor.mostReadable(highlightBgColor, [textColor.toRgbString(), '#fff', '#000'], {
          includeFallbackColors: true
        })
      };
    });
    function handleClick(e) {
      // Only emit on click of an anchor tag
      if (!e.target.href) return;
      emit('click', {
        href: e.target.href,
        text: e.target.innerText
      });
    }
    return {
      id,
      html,
      classes,
      styles,
      handleClick
    };
  }
};
export { script as default };